const ENVIRONMENT = 'dev';

// API
const server = {
  dev: {
    baseUrl: 'https://ctn1.test.tcrs.axetacloud.ru/',
    apiBaseUrl: 'https://ctn1.test.tcrs.axetacloud.ru/api/v1/',
  },
  prod: {
    baseUrl: 'https://ctn1.test.tcrs.axetacloud.ru/',
    apiBaseUrl: 'https://ctn1.test.tcrs.axetacloud.ru/api/v1/',
  },
};

export const baseUrl = server[ENVIRONMENT].baseUrl;
export const apiBaseUrl = server[ENVIRONMENT].apiBaseUrl;
export const apiDefaultTimeout = 15 * 1000;
